// Where the current match shows on this page, shared by the match dock (its
// own root outside #page_content) and the home page (the page area's root),
// which render in separate React trees.
//
// The home page's match column (react/home/HomeMatchColumn) says when it
// shows; the dock reads that with useSyncExternalStore and sends the bar's
// actions to the column instead of the sheet. The dock hands over a way to
// open its sheet, so openCurrentMatch() (the home page's "Return to your
// match") can open the match in place: the column if it shows, else the
// sheet. It returns false when neither can, and the caller follows its link.
//
// The dock also reports the match it shows (reportCurrentMatch), so the home
// page's play bar follows the match as it starts and ends instead of keeping
// the one the page loaded with. Until the dock reports, the match is unknown
// (undefined) and the page goes by what the server rendered.
// Nothing here touches the browser, so the server render can import it.

let homeColumn = null;
let sheetOpener = null;
let currentMatch;
const listeners = new Set();

function notify() {
	listeners.forEach((listener) => listener());
}

export function subscribeToMatchDockPlacement(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function isHomeMatchColumnShowing() {
	return homeColumn !== null;
}

// The server render and the hydrating render have no column.
export function isHomeMatchColumnShowingOnServer() {
	return false;
}

// column: { focus() }. Returns a function that takes it away again.
export function showHomeMatchColumn(column) {
	homeColumn = column;
	notify();
	return () => {
		if(homeColumn === column) {
			homeColumn = null;
			notify();
		}
	};
}

// open() returns true when it opened the sheet.
export function setMatchSheetOpener(open) {
	sheetOpener = open;
	return () => {
		if(sheetOpener === open) {
			sheetOpener = null;
		}
	};
}

export function openCurrentMatch() {
	if(homeColumn) {
		homeColumn.focus();
		return true;
	}
	return sheetOpener ? sheetOpener() === true : false;
}

// match: { match_id, opponent_name }, or null for none. Returns a function
// that makes the match unknown again.
export function reportCurrentMatch(match) {
	const unchanged = match && currentMatch
		? match.match_id === currentMatch.match_id && match.opponent_name === currentMatch.opponent_name
		: match === currentMatch;
	if(!unchanged) {
		currentMatch = match;
		notify();
	}
	return forgetCurrentMatch;
}

export function forgetCurrentMatch() {
	currentMatch = undefined;
	notify();
}

export function currentMatchFromDock() {
	return currentMatch;
}

// The server render and the hydrating render go by the server's match.
export function currentMatchFromDockOnServer() {
	return undefined;
}
